// extracted by mini-css-extract-plugin
export default {"projects":"style_projects__txsJq","loading":"style_loading__v4cXj"};